import React, { useState } from "react";

import Button from "../Button/Button";
import Checkbox from "../Checkbox/Checkbox";

import "./HerdingScoresheetsFilterModal.scss";

interface IProps {
  onDownload: (includeAlternates: boolean) => void;
  onCancel: () => void;
}

const HerdingScoresheetsFilterModal: React.FC<IProps> = (props) => {
  const [includeAlternates, setIncludeAlternates] = useState<boolean>(false);

  return (
    <div className="herding-scoresheets-filter-modal">
      <h2>Download Scoresheets</h2>
      <p>Choose whether to include blank scoresheets for waitlisted "Alternate" entries.</p>

      <Checkbox
        id="includeAlternates"
        className={`filter-option ${includeAlternates ? "selected" : ""}`}
        value={includeAlternates}
        onChange={(e: any) => setIncludeAlternates(e.target.checked)}
        label={
          <div className="option-content">
            <div className="option-title">Include Alternates</div>
            <div className="option-description">
              Adds a blank scoresheet for each waitlisted entry ("-ALT" armband) after the real entries in its class
            </div>
          </div>
        }
      />

      <div className="modal-actions">
        <Button className="cancel" onClick={props.onCancel} type="button">Cancel</Button>
        <Button onClick={() => props.onDownload(includeAlternates)} type="button">Download</Button>
      </div>
    </div>
  );
};

export default HerdingScoresheetsFilterModal;
